import { render, staticRenderFns } from "./AboutCharte.vue?vue&type=template&id=1df36412&"
import script from "./AboutCharte.vue?vue&type=script&lang=js&"
export * from "./AboutCharte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports